import * as React from 'react'

import { TUserListener, UserListenerContext } from './context'

export const withUserListenerProvider = Component => props => {
  const [userListener, setUserListener] = React.useState<TUserListener>(null)

  return (
    <UserListenerContext.Provider
      value={{
        userListener,
        setUserListener
      }}
    >
      <Component {...props} />
    </UserListenerContext.Provider>
  )
}



// WEBPACK FOOTER //
// ./src/components/UserListener/withUserListenerProvider.tsx